module.exports = __webpack_public_path__ + "img/cafe_restaurant.080a2624.png";